import { computed, type Ref } from 'vue'

import { type ProjectStatus } from '@/constants/persoplan'
import scssVariables from '@/assets/scss/scssVariables'
import type { Nilable } from '@/types/misc'

export type { ProjectStatus } from '@/constants/persoplan'

interface Options {
  status: Ref<Nilable<ProjectStatus>>
}

const colors = {
  confirmed: scssVariables.color['status-project-confirmed'],
  cancelled: scssVariables.color['status-project-cancelled'],
  offered: scssVariables.color['status-project-offered'],
  service: scssVariables.color['status-project-service'],
} as const satisfies Record<ProjectStatus, string>

export function useProjectStatus(options: Options) {
  const classes = computed(() => {
    if (!options.status.value) return

    return {
      [`is-statusProject-${options.status.value}`]: true,
    }
  })

  const color = computed(() => {
    if (!options.status.value) return

    return colors[options.status.value]
  })

  return {
    id: options.status.value,
    classes,
    color,
  }
}
